import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import ArticleItem from '~/components/Layout/Builders/ArticleItem';
import type { ArticleItemType } from '~/types/ArticleItemType';

type ArticleBuilderType = {
  items: ArticleItemType[];
};

export default component$<ArticleBuilderType>(({ items }): JSX.Element => {
  return items.map((each, index) => <ArticleItem key={index} item={each} />);
});
